export default "__VITE_ASSET__CAgwHwyz__"